var _linearGradient, _path, _ellipse, _ellipse2, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _ellipse3, _linearGradient7, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionExtensions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208",
    gradientUnits: "userSpaceOnUse",
    x1: -5983.259,
    y1: -246.52,
    x2: -5982.259,
    y2: -246.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M61.366 68.021l47.846 19.463v38.925l-47.846-18.651zM109.212 87.484l25.139-13.786v38.114l-25.139 14.597M73.527 63.282l-12.161 4.739M109.391 64.624L96.28 59.7M134.351 73.698l-13.967-5.084M98.281 70.407v4.701c0 2.692 4.989 4.875 11.142 4.875s11.142-2.182 11.142-4.875v-4.701M73.733 60.484v4.701c0 2.692 4.989 4.875 11.142 4.875s11.142-2.182 11.142-4.875v-4.701"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 109.423,
    cy: 69.711,
    rx: 11.142,
    ry: 4.875
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 84.875,
    cy: 59.787,
    rx: 11.142,
    ry: 4.875
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208",
    gradientUnits: "userSpaceOnUse",
    x1: 107.864,
    y1: 35.45,
    x2: 134.595,
    y2: 35.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M109.114 36.218l24.231-13.288v12.115l-24.148 12.926"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208",
    gradientUnits: "userSpaceOnUse",
    x1: 83.914,
    y1: 23.078,
    x2: 99.275,
    y2: 23.078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.025 20.05l-12.861 6.056"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208",
    gradientUnits: "userSpaceOnUse",
    x1: 119.216,
    y1: 20.914,
    x2: 134.595,
    y2: 20.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M133.345 22.93l-12.879-4.031"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208",
    gradientUnits: "userSpaceOnUse",
    x1: 97.328,
    y1: 24.373,
    x2: 121.307,
    y2: 24.373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.578 19.758v4.531c0 2.595 4.808 4.699 10.74 4.699 5.931 0 10.74-2.104 10.74-4.699v-4.531",
    fill: "none",
    stroke: "url(#SVGID_4_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208",
    gradientUnits: "userSpaceOnUse",
    x1: 97.328,
    y1: 19.087,
    x2: 121.307,
    y2: 19.087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.318,
    cy: 19.087,
    rx: 10.74,
    ry: 4.699,
    fill: "none",
    stroke: "url(#SVGID_5_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208",
    gradientUnits: "userSpaceOnUse",
    x1: 83.651,
    y1: 37.155,
    x2: 110.364,
    y2: 37.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_eb3289a43f43127f6c02213211fe32cb925d8a6df1ed726f6a8e306196169208)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.901 26.368l24.213 9.85v11.724L84.901 37.637z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionExtensions);
export default __webpack_public_path__ + "static/media/subscriptionExtensions.928dee2b3d727ef470666b9cc43b8bf7.svg";
export { ForwardRef as ReactComponent };